import { render, staticRenderFns } from "./DataUploadComp.vue?vue&type=template&id=50b1d41f&"
import script from "./DataUploadComp.vue?vue&type=script&lang=js&"
export * from "./DataUploadComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports